import { SHIPPED_MODULES } from "@/config/modules";

/**
 * Every scope a saved view can plausibly exist under.
 *
 * `SectionPage` scopes saved views per section: the module's first section
 * uses the bare module id (`orders`), every other section
 * `<module>.<section>` (`orders.shipments`). See `routes/SectionPage.tsx` for
 * why a module-wide scope applied one list's view to another's rows.
 *
 * Not narrowed to "sections with a list" by consulting the module registry:
 * `modules/registry.ts` imports every module, including this one, so importing
 * it back from here would make `@/modules/registry` and `@/modules/settings`
 * import each other. `SavedViewsAdmin` already drops every scope that comes
 * back with zero views, so the imprecision costs one empty request per such
 * section.
 */
export function savedViewScopes(): string[] {
  return SHIPPED_MODULES.flatMap((module) =>
    module.sections.map((section, index) =>
      index === 0 ? module.id : `${module.id}.${section.id}`,
    ),
  );
}
